import styles from "../reseller.module.css"

export function ResellerPerks() {
  const perks = [
    {
      title: "Exclusive Catalog Access",
      description: "Access full product catalog at exclusive reseller rates",
      icon: "📦",
    },
    {
      title: "Automated Top-ups",
      description: "Seamless automated top-ups via Nexus system",
      icon: "⚡",
    },
    {
      title: "Real-time Notifications",
      description: "Get instant order notifications through Pixie",
      icon: "🔔",
    },
    {
      title: "Flash Deals",
      description: "Access special reseller-only flash deals & loyalty boosts",
      icon: "⚡",
    },
    {
      title: "Custom Margins",
      description: "Earn profit by setting your own competitive margins",
      icon: "💰",
    },
    {
      title: "VIP Tiers",
      description: "Climb VIP tiers for double benefits—discounts + perks",
      icon: "👑",
    },
  ]

  return (
    <section className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Reseller Perks</h2>
        <p className={styles.sectionSubtitle}>Unlock exclusive benefits and maximize your earnings</p>
      </div>

      <div className={styles.perksGrid}>
        {perks.map((perk, index) => (
          <div key={index} className={styles.perkCard}>
            {/* Icon */}
            <div className={styles.perkIcon}>{perk.icon}</div>

            {/* Title */}
            <h3 className={styles.perkTitle}>{perk.title}</h3>

            {/* Description */}
            <p className={styles.perkDescription}>{perk.description}</p>

            {/* Accent line */}
            <div className={styles.perkAccent}></div>
          </div>
        ))}
      </div>
    </section>
  )
}
